import { h, Host } from "@stencil/core";
export class ScrollToTop {
    constructor() {
        this.active = false;
    }
    async componentWillLoad() {
        this.observer = new IntersectionObserver((entries) => {
            this.active = !entries[0].isIntersecting;
        }, { rootMargin: '300px 10px 0px 10px' });
        this.observer.observe(document.querySelector('#content'));
    }
    clickHandler() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    render() {
        return (h(Host, { key: 'fcd30dff7cd516f71ecacf0487b2279c3c947b91', role: "button", title: "Scroll to top", class: { 'active': this.active } }, h("svg", { key: 'fd1e5835158df99b64dab521bf80ebbdbcb54e55', xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 448 512", width: "24", height: "24" }, h("path", { key: 'dcbc32c89f70b266577ed1a777a0f186716ebe84', d: "M6.101 359.293L25.9 379.092c4.686 4.686 12.284 4.686 16.971 0L224 198.393l181.13 180.698c4.686 4.686 12.284 4.686 16.971 0l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L232.485 132.908c-4.686-4.686-12.284-4.686-16.971 0L6.101 342.322c-4.687 4.687-4.687 12.285 0 16.971z" }))));
    }
    static get is() { return "scroll-to-top"; }
    static get originalStyleUrls() {
        return {
            "$": ["./scroll-to-top.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["scroll-to-top.css"]
        };
    }
    static get states() {
        return {
            "active": {}
        };
    }
    static get listeners() {
        return [{
                "name": "click",
                "method": "clickHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=scroll-to-top.js.map
